module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-3-ec7a0c834b4f07c8321f7847683304c6.jpg";